import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { GoAlert } from "react-icons/go";
import { apiRoutes } from "../../hooks/apiClient";
import PaginatedView from "../../components/UI/PaginatedView/PaginatedView";
import NotificacaoDetalhamento from "./NotificacaoDetalhamento";
import { AuthContext } from "../../context/AuthContext";
import { formatarData } from "../../components/Formatters/DateTime";

const acaoCell = (row) => {
  const dataLeitura = formatarData(row.leitura, "dd/MM/yyyy HH:mm:ss");
  let status = "";
  if (row.status === "LI") {
    status = `Lida em ${dataLeitura}`;
  } else {
    status = row.statusShow;
  }

  return row.leitura ? <span>{status}</span> : <b style={{ color: "black" }}>{status}</b>;
};

const columns = [
  {
    name: "",
    cell: (row) => {
      let btnClass = "";

      if (row.dados === "verde") {
        btnClass = "btn-sm text-success pa-0 p-0";
      } else if (row.dados === "vermelho") {
        btnClass = "btn-sm text-danger pa-0 p-0";
      } else if (row.dados === "amarelo") {
        btnClass = "btn-sm text-alert pa-0 p-0";
      }

      return (
        <Button variant="bg-transparent" className={btnClass}>
          <GoAlert />
        </Button>
      );
    },
    center: true,
    width: "1%",
  },
  {
    name: "Título da Mensagem",
    sortable: true,
    cell: (row) => (row.leitura ? <span> {row.titulo}</span> : <b style={{ color: "black" }}>{row.titulo}</b>),
  },
  {
    name: "Data de Envio",
    cell: (row) =>
      row.leitura ? (
        <span>{formatarData(row.envio, "dd/MM/yyyy HH:mm:ss")}</span>
      ) : (
        <b style={{ color: "black" }}>{formatarData(row.envio, "dd/MM/yyyy HH:mm:ss")}</b>
      ),
  },

  {
    name: "Status",
    cell: acaoCell,
    sortable: true,
  },
];

const Notificacoes = ({ history }) => {
  const { unreadNotifications } = useContext(AuthContext);
  const [queryService, setQueryService] = useState({
    ...apiRoutes.usuarios.notificacao.listarnotificacaoefis,
    unreadCount: 0,
  });

  useEffect(() => {
    // Atualizar lista no caso de novas notificações (não leitura)
    if (unreadNotifications.length > queryService.unreadCount) {
      setQueryService({
        ...apiRoutes.usuarios.notificacao.listarnotificacaoefis,
        unreadCount: (unreadNotifications || []).length,
      });
    }
  }, [unreadNotifications, queryService]);

  const conditionalRowStyles = [
    {
      when: (row) => row.leitura,
      style: { fontWeight: "300", color: "black" },
    },
  ];

  const atualizarCell = (estado, row) => {
    if (estado) {
      acaoCell(row);
    } else {
      setQueryService({
        ...apiRoutes.usuarios.notificacao.listarnotificacaoefis,
        unreadCount: (unreadNotifications || []).length,
      });
    }
  };

  return (
    <PaginatedView
      title="Notificações"
      keyField="id"
      descriptionField="titulo"
      defaultSearch
      defaultSearchPlaceholder="Título ou Conteúdo"
      queryService={queryService}
      columns={columns}
      expandComponent={NotificacaoDetalhamento}
      history={history}
      conditionalRowStyles={conditionalRowStyles}
      expandableRows
      handleRowExpandToggle={(estado, row) => atualizarCell(estado, row)}
    />
  );
};

export default Notificacoes;
